import React from "react";
import { Grid, Paper, makeStyles } from "@material-ui/core";
// import MainToolbar from "../MainToolbar";
// import Sidebar from "../Sidebar";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "70vh",
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
  },

  form: {
    padding: theme.spacing(1, 2, 2),
  },
}));

const ReportLayoutPage = ({ children, filter }) => {
  const classes = useStyles();
  return (
    <div >
      {/* <Sidebar /> */}
      <div >
        <Grid container spacing={12}>
          <Grid item xs={12} md={12} lg={12} style={{marginBottom:"12px"}}>
          {filter}
          </Grid>
          <Grid item xs={12} md={9} lg={12} className={classes.root} style={{backgroundColor:'white'}} >
            {children}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ReportLayoutPage;
